import { categories } from '../constants';
import { MedisanteOrgReport } from '../types';

export const getSignalStrengthData = (
  reports: MedisanteOrgReport[],
  avg: boolean = false
) => {
  const ok = reports.reduce(
    (agg, report) =>
      agg + (avg ? report.signalStrengthAverageOK : report.signalStrengthOK),
    0
  );
  const warning = reports.reduce(
    (agg, report) =>
      agg +
      (avg
        ? report.signalStrengthAverageWarning
        : report.signalStrengthWarning),
    0
  );
  const critical = reports.reduce(
    (agg, report) =>
      agg +
      (avg
        ? report.signalStrengthAverageCritical
        : report.signalStrengthCritical),
    0
  );

  return {
    totalCount: ok + warning + critical,
    okCount: ok,
    warningCount: warning,
    criticalCount: critical,
    chartData: [
      {
        name: categories.OK.name,
        key: categories.OK.value,
        val: ok,
      },
      {
        name: categories.WARNING.name,
        key: categories.WARNING.value,
        val: warning,
      },
      {
        name: categories.CRITICAL.name,
        key: categories.CRITICAL.value,
        val: critical,
      },
    ],
  };
};
